import React from 'react';
import { MDCAnchorMenu, MDCMenu } from '../../jsx/components/mdc-components';
export class Container extends React.Component {
  render() {
    var cls = 'body';
    if (this.props.cls) {
      cls += ' ' + this.props.cls;
    }
    var css = 'container';
    if (this.props.css) {
      css += ' ' + this.props.css;
    }
    return /*#__PURE__*/React.createElement("section", {
      className: css
    }, /*#__PURE__*/React.createElement("span", {
      className: "medium"
    }, this.props.title), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
      className: cls
    }, this.props.children));
  }
}
export class LinkContainer extends React.Component {
  render() {
    var cls = 'body';
    if (this.props.cls) {
      cls += ' ' + this.props.cls;
    }
    var css = 'container';
    if (this.props.css) {
      css += ' ' + this.props.css;
    }
    return /*#__PURE__*/React.createElement("section", {
      className: css
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-box space-between container-padding"
    }, /*#__PURE__*/React.createElement("span", {
      className: "medium"
    }, this.props.title), /*#__PURE__*/React.createElement("a", {
      onClick: this.props.onClick,
      className: "container-link"
    }, this.props.linkText, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "arrow_right"))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
      className: cls
    }, this.props.children));
  }
}
export class SimpleContainer extends React.Component {
  render() {
    var cls = 'container';
    if (this.props.cls) {
      cls += ' ' + this.props.cls;
    }
    return /*#__PURE__*/React.createElement("section", {
      className: cls
    }, this.props.children);
  }
}
export class CssContainer extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: this.props.cls
    }, this.props.children);
  }
}
export class FormContainer extends React.Component {
  render() {
    var cls = 'panel-form-container';
    if (this.props.cls) {
      cls = this.props.cls;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, this.props.children);
  }
}
export class FormElement extends React.Component {
  render() {
    var cls = '';
    if (this.props.cls) {
      cls = this.props.cls;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, this.props.children);
  }
}
export class TabContainer extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement("div", null, this.props.children);
  }
}
export class PanelContainer extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "panel-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "header"
    }, this.props.title), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
      className: "body"
    }, this.props.children));
  }
}
export class PanelActivityContainer extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  get nodes() {
    var index = 0;
    var nodes = this.props.items.map(item => {
      index += 1;
      return /*#__PURE__*/React.createElement("li", {
        key: index,
        className: "mdc-list-item",
        role: "menuitem",
        tabIndex: "0",
        "data-value": item.value,
        "data-id": item.id,
        "data-text": item.text
      }, item.text);
    });
    return nodes;
  }
  render() {
    var nodes = this.nodes;
    return /*#__PURE__*/React.createElement("div", {
      className: "panel-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "header"
    }, /*#__PURE__*/React.createElement("div", null, this.props.title), this.props.items.length > 0 && /*#__PURE__*/React.createElement(MDCAnchorMenu, {
      menuId: this.props.id,
      onMenuSelected: this.props.onSelected,
      cls: "small-list-item-size"
    }, /*#__PURE__*/React.createElement("button", {
      className: "anchor-menu-button",
      "data-anchor": true
    }, this.props.selection, " ", /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "arrow_drop_down")), /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: this.props.id
    }, nodes))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
      className: "body"
    }, this.props.children));
  }
}
export class PanelContentContainer extends React.Component {
  render() {
    var cls = 'panel-content-container';
    if (this.props.cls) {
      cls = this.props.cls;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, this.props.children);
  }
}
export class SocialIconLink extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  render() {
    return /*#__PURE__*/React.createElement("a", {
      className: "social-icon-container",
      href: this.props.link,
      target: "_blank"
    }, /*#__PURE__*/React.createElement("img", {
      src: this.props.src
    }));
  }
}
export class FlexboxContainer extends React.Component {
  render() {
    var cls = "flex-box";
    if (this.props.cls) {
      cls += ' ' + this.props.cls;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, this.props.children);
  }
}
export default {
  Container,
  LinkContainer,
  SimpleContainer,
  CssContainer,
  FormElement,
  TabContainer,
  FormContainer,
  PanelContainer,
  PanelContentContainer,
  SocialIconLink,
  FlexboxContainer,
  PanelActivityContainer,
  FlexboxContainer
};